import React, { useEffect, useState } from 'react';
import PublicService from 'services/PublicService';
import { Box, Grid } from '@mui/material';
import ActivityCard from 'components/ActivityCard';
import AddBookmark from 'components/AddBookmark';
import { useLoading } from 'hooks/useLoading';
import { IBusiness } from 'interfaces/IBusinesses';
import { Container } from 'features/Activities/pages/List/styles';

const TransportsList = (): JSX.Element => {
  const getActivities = async () => {
    const service = new PublicService();
    return service.getAllTransports();
  };

  return <TransportsListComponent getActivities={getActivities} />;
};

export default TransportsList;

interface IProps {
  getActivities: () => Promise<IBusiness[]>;
}

export const TransportsListComponent = (props: IProps): JSX.Element => {
  const [activities, setActivities] = useState<IBusiness[]>([]);
  const { openLoading, closeLoading } = useLoading();

  useEffect(() => {
    getActivities();
  }, []);

  const getActivities = async () => {
    try {
      openLoading();
      const data = await props.getActivities();
      setActivities(data);
      closeLoading();
    } catch (error) {
      closeLoading();
    }
  };

  return (
    <Container>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={4}>
          {activities?.map((activity, index) => (
            <Grid key={index} xs={12} sm={6} md={4} lg={3} xl={3} item>
              <ActivityCard
                image={Array.isArray(activity.image) ? activity.image[0] : activity.image}
                category={activity.businessType}
                title={activity.title ? activity.title : activity.tradeName}
                description={activity.description}
                link={`/services/transports/${activity.id}`}
                action={<AddBookmark type="business" id={activity.id} />}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};
